import * as at from "../actions/types";

const initialState = {
  visible: false,
};

const sidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case at.TOGGLE_SIDEBAR:
      return {
        ...state,
        visible: !state.visible,
      };
    default:
      return state;
  }
};
export default sidebarReducer;
